export enum WalletPlatform {
  NEON = 'neon',
  NEOLINE = 'neoline',
  ONEGATE = 'onegate',
  METAMASK = 'metamask',
}
